export default __webpack_public_path__ + "static/media/2.1ba0eb3d.mp4";